@if (tried.lifeTest?.length) {
    <div class="item-group">
        <tec-info-group>
            <span>{{ ('GENERAL.TRIED' | translate : { num: index + 1 }).toUpperCase() }}</span>
            <tec-tag
                [label]="'MASTER.POL_STATUS.' + tried.general.status?.toUpperCase() | translate"
                [status]="masterService.getTagStatusPol(tried.general.status)"
        />
        </tec-info-group>
        @for (lifeTest of tried.lifeTest; track $index) {
            <tec-item
                [title]="
                    ('MASTER.POL_TESTS.' + lifeTest.lifeTestId?.toUpperCase() | translate) +
                    (lifeTest.scoring?.totalTries > 1
                        ? '(' + ('GENERAL.TRIED_AUX' | translate : { num: lifeTest.scoring?.totalTries }) + ')'
                        : '')
                "
                [tagIcon]="{
                    icon: masterService.getTagStatusPol(lifeTest.status) === 'success' ? 'icon-check' : 'icon-alert',
                    status: masterService.getTagStatusPol(lifeTest.status),
                    size: 'sm'
                }"
                [detailAction]="lifeTest.finishAt | date : 'dd/MM/yyyy - HH:mm:ss'"
            >
                @if (lifeTest.scoring?.totalTime || lifeTest.scoring?.result) {
                    <tec-list-detail>
                        @if (lifeTest.scoring?.totalTime) {
                        <span>{{
                            lifeTest.scoring?.totalTime ? (lifeTest.scoring?.totalTime | number : '1.0-0') + ' s' : ''
                        }}</span>
                        } @if (lifeTest.scoring?.result) {
                        <span>{{
                            lifeTest.scoring?.result ? (lifeTest.scoring?.result | number : '1.0-1') + ' ptos' : ''
                        }}</span>
                        }
                    </tec-list-detail>
                } @else {
                    <span>{{ polFailReasonService.getPolTestFailReasonFromFullScoring(lifeTest) | translate }}</span>
                }
            </tec-item>
        }
        @if (tried.general?.scoring) {
            <tec-item
                [title]="'PROCESSES.DETAIL.RESULT' | translate"
                [tagIcon]="{
                    icon: processHelper.isPolGeneralResultOk(tried.general) ? 'icon-check' : 'icon-alert',
                    status: processHelper.isPolGeneralResultOk(tried.general) ? 'success' : 'error',
                    size: 'sm'
                }">
                @if (tried.general?.scoring?.totalTime || tried.general?.scoring?.result) {
                    <tec-list-detail>
                        <span>{{ tried.general?.scoring?.result ? (tried.general?.scoring?.result | number:'1.0-1') + ' ptos' : '' }}</span>
                        <span>
                            {{ processHelper.isPolGeneralResultOk(tried.general) ? ('PROCESSES.DETAIL.POL_OK' | translate) : ('PROCESSES.DETAIL.POL_KO' | translate) }}
                            <tec-tooltip [label]="'PROCESSES.DETAIL.POL_TRIED_EXPLICATION' | translate">
                                <tec-icon style="margin-left: 3px;" name="icon-info"></tec-icon>
                            </tec-tooltip>
                        </span>
                    </tec-list-detail>
                }
            </tec-item>
        }
    </div>
}
